<template>
  <div>
    <div class="page-head"><div><h1>时长流水</h1><p>充值、签到扣时长与撤销记录</p></div></div>
    <div class="panel">
      <div class="toolbar">
        <el-input v-model="query" placeholder="输入中文学员姓名" clearable style="width:220px" @keyup.enter.native="load" />
        <el-select v-model="classId" clearable filterable placeholder="按班级筛选" style="width:340px" @change="load">
          <el-option v-for="item in classes" :key="item.id" :value="item.id" :label="classLabel(item)" />
        </el-select>
        <el-button @click="load">搜索</el-button>
      </div>
      <div v-if="classId" class="attendance-summary">
        <span>该班预约 <b>{{ activeCount }}</b> 人</span><span class="attended">已签到 <b>{{ attendedCount }}</b> 人</span><span v-if="pendingCount" class="pending">待签到 <b>{{ pendingCount }}</b> 人</span><span v-else class="complete">已全部签到</span>
      </div>
      <el-table :data="rows" v-loading="loading" style="width:100%">
        <el-table-column prop="created_at" label="发生时间" width="180" />
        <el-table-column prop="member_name" label="学员" width="130" />
        <el-table-column label="类型" width="130"><template slot-scope="{row}">{{ typeText(row.type) }}</template></el-table-column>
        <el-table-column prop="class_title" label="关联课程" min-width="180"><template slot-scope="{row}">{{ row.class_title || '时长充值' }}</template></el-table-column>
        <el-table-column label="时长变动" width="130"><template slot-scope="{row}"><b :style="{color:row.delta>0?'#4b7666':'#a57070'}">{{ row.delta > 0 ? '+' : '' }}{{ hours(row.delta) }} 小时</b></template></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { listLedger, listClasses, roster } from '../api'
export default {
  data: () => ({ rows: [], query: '', classId: '', classes: [], rosterRows: [], loading: false }),
  computed: {
    activeCount () { return this.rosterRows.filter(row => row.status === 'booked' || row.status === 'attended').length },
    attendedCount () { return this.rosterRows.filter(row => row.status === 'attended').length },
    pendingCount () { return this.rosterRows.filter(row => row.status === 'booked').length }
  },
  created () { this.loadClasses(); this.load() },
  methods: {
    typeText (type) { return ({ opening: '开卡充值', recharge: '充值', checkin: '签到课消', undo: '撤销签到' })[type] || type },
    classLabel (item) { return `${item.start_at.slice(0, 16)} · ${item.title} · ${item.teacher}` },
    async loadClasses () { try { this.classes = await listClasses() } catch (e) { this.$message.error(e.message) } },
    async load () {
      this.loading = true
      try {
        const requests = [listLedger(this.query, this.classId)]
        if (this.classId) requests.push(roster(this.classId))
        const result = await Promise.all(requests)
        this.rows = result[0]
        this.rosterRows = this.classId ? result[1] : []
      } catch (e) { this.$message.error(e.message) } finally { this.loading = false }
    },
    hours (minutes) { return Number((Number(minutes || 0) / 60).toFixed(2)) }
  }
}
</script>
<style scoped>
.attendance-summary { margin: 0 0 18px; padding: 12px 16px; border-radius: 6px; background: #f6f8f7; color: #58645f; }
.attendance-summary span { margin-right: 22px; }
.attended, .complete { color: #4b7666; }
.pending { color: #a57070; }
</style>
